var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisitsAnalytics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#496DFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18V35C18 36.66 19.34 38 21 38H38",
    stroke: "#1A1515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 33L25.59 27.64C26.35 26.76 27.7 26.7 28.52 27.53L29.47 28.48C30.29 29.3 31.64 29.25 32.4 28.37L37 23",
    stroke: "#1A1515",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitsAnalytics);
export default __webpack_public_path__ + "static/media/visitsAnalytics.eb505a32c3e64d6c68bdf60721bc1ece.svg";
export { ForwardRef as ReactComponent };